// イベントハンドラ（ページが読まれたら実行）
window.addEventListener("load", function () {

  // アドレスバーに #id があるとき、 id を抽出
  let hashId = location.hash && location.hash.substr(1);

  // タブ用 input[name=tab_item] コレクション
  let tabs = document.querySelectorAll("input[name=tab_item]");

  // 個々の タブ用 input[name=tab_item] を調整
  for (let tab of tabs) {

    // URL欄に #inputId でアクセスされている場合 cheked 属性を切り替える
    // => CSS でタブコンテンツが表示される。
    if (hashId) {
      tab.checked = tab.id == hashId;
    }

    // イベントハンドラ（アンカー代わりに location.href を置き換え）
    tab.addEventListener("input", function (evt) {
      evt.preventDefault(); // ← ★ これを追加！ページジャンプ防止
      evt.stopPropagation(); // ← ★ 念のためイベント伝播も止める（安全策）

      // location.replace でURLハッシュを更新
      location.replace(`#${evt.target.id}`);
    });
  }

});
